// 🎚️ On/off switches for features.
// MoMo direct payment (send to our MoMo number, admin confirms) is "Coming soon" for now.
// To switch it on later: change false to true here AND in functions/start-checkout.ts, then git push.
export const MOMO_DIRECT_ENABLED = false;

// 🛠️ "We're doing a quick upgrade" notice
//   "auto" = show it only when our backend (Nhost) can't be reached — it disappears by itself when it's back
//   "on"   = always show it
//   "off"  = never show it
export const MAINTENANCE_MODE: "auto" | "on" | "off" = "auto";

// Your WhatsApp for urgent manual orders while the site is upgrading (233 = Ghana, without the first 0)
export const URGENT_WHATSAPP = "233247204860";
